module.exports = __webpack_public_path__ + "media/components/country-flag/static/lu-296da2c9e72a9313462b75117420cb07.svg";